/**
 * lib/supabaseClient.ts
 * Small helper to create a Supabase client only when URL and key are provided.
 */

import { createClient, SupabaseClient } from '@supabase/supabase-js'

/**
 * createClientOrNull
 * Returns a Supabase client if url/key are valid strings; otherwise null.
 */

const supabaseUrl = "https://ihadunvxldksjgmanlrz.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImloYWR1bnZ4bGRrc2pnbWFubHJ6Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1Njc1MDM1NCwiZXhwIjoyMDcyMzI2MzU0fQ.xu7njY5i3kaK0nb7cmX2sFX7yHkkDv7UvAkbA-5Iuhg"

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export function createClientOrNull(url?: string, key?: string): SupabaseClient | null {
  const cleanUrl = url?.trim()
  const cleanKey = key?.trim()
  if (!cleanUrl || !cleanKey) return null
  try {
    return createClient(cleanUrl, cleanKey)
  } catch {
    return null
  }
}
